import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: { width: 'fit-content' as const },
    text: {
        padding: '.25rem .4rem',
        fontSize: '18px',
        fontWeight: 'bold' as 'bold',
        lineHeight: 1,
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        border: `1px solid ${theme?.app?.clientTheme.colors.primaryColor || '#375073'}`,
        borderRadius: '3px'
    }
}));